<div>
  <div mat-dialog-title class="dialog-title-row"><span class="header-font">{{data.header}}</span>
  <span>
    <mat-icon id="close-icon" class="pointer" (click)="closeDialog()" >close</mat-icon> </span>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content >
    <span>
      @for (item of data.data; track item) {
        <ul>
          <li class="max-width-item">{{item}}</li>
        </ul>
      }
    </span>
  </div>
</div>
